import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingService, ITrackingObject } from 'i2g-ng-tracking';
import { ChangeEmailErrorBuilder } from './change-email-error.builder';
import { Observable } from 'rxjs';
import { AccountStore } from '../../store/stores';
import { shareReplay } from 'rxjs/operators';
import { AlignmentEnum, IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';

@Component({
  selector: 'app-change-email-error',
  templateUrl: './change-email-error.component.html',
  styleUrls: ['./change-email-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ChangeEmailErrorBuilder],
})
export class ChangeEmailErrorComponent implements OnInit, AfterViewInit {
  errorIcon: IIcon;
  trackingScreenName: TrackingScreenNamesEnum;
  trackingObject$: Observable<ITrackingObject>;
  loginRoute: IRouter;
  alignmentEnum: typeof AlignmentEnum;

  constructor(
    private _router: Router,
    private _trackingService: I2gNgTrackingService,
    private _changeEmailErrorBuilder: ChangeEmailErrorBuilder,
    private _accountStore: AccountStore
  ) {}

  ngOnInit() {
    this.trackingScreenName = TrackingScreenNamesEnum.change_email_failed;
    this.trackingObject$ = this._accountStore
      .getTrackingObject()
      .pipe(shareReplay(1));
    this.loginRoute = this._changeEmailErrorBuilder.buildLoginRoute();
    this.alignmentEnum = AlignmentEnum;

    this.errorIcon = {
      name: 'error',
      size: IconSizesEnum.custom,
    };
  }

  ngAfterViewInit() {
    this._trackingService.trackPage(this.trackingScreenName);
  }
}
